const RIGHTS_PROFILES_ENDPOINTS = {
  BASE: '/rights-profiles',
  CATALOGUE: '/rights-profiles/catalogue',
  BY_ID: (id: string) => `/rights-profiles/${id}`,
};

export default RIGHTS_PROFILES_ENDPOINTS;
